import { useCareTeamSelector } from './useCareTeamSelector';
import { useCallback } from 'react';
import { ChannelType } from '../../type';

export const useUnreadCount = (
  filter:
    | 'all'
    | { type: 'channelType'; channelType: ChannelType }
    | { type: 'patient'; guid: string }
    | { type: 'channel'; guid: string },
): number => {
  return useCareTeamSelector(
    useCallback(
      (state) => {
        if (state === 'LOADING') {
          return 0;
        }
        const userGuid = state.currentUserGuid;
        const channels = state.channels;
        if (filter === 'all') {
          return Object.values(channels).reduce((sum, channel) => {
            return sum + (channel.unreadEstimations?.[userGuid] ?? 0);
          }, 0);
        } else if (filter.type === 'patient') {
          return Object.values(channels).reduce((sum, channel) => {
            if (channel.attributes.patientGuid === filter.guid) {
              return sum + (channel.unreadEstimations?.[userGuid] ?? 0);
            }
            return sum;
          }, 0);
        } else if (filter.type === 'channelType') {
          return Object.values(channels)
            .filter((channel) => channel.type === filter.channelType)
            .reduce((sum, channel) => {
              return sum + (channel.unreadEstimations?.[userGuid] ?? 0);
            }, 0);
        } else {
          return channels[filter.guid]?.unreadEstimations?.[userGuid] ?? 0;
        }
      },
      [filter],
    ),
  );
};
